import { Input } from "@/components/ui/input";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { TIPOS_UNIDAD, tipoOf } from "@/lib/leadPeriod";

const PERIODOS = [
  ["todo", "Todo el historial"], ["hoy", "Hoy"], ["semana", "Esta semana (lun–dom)"],
  ["mes", "Este mes"], ["rango", "Rango personalizado"],
];

export function LeadPeriodControls({ value, onChange, prefix, showTipo = true }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <>
      <Select value={value.period} onValueChange={(v) => set("period", v)}>
        <SelectTrigger className="w-56" data-testid={`${prefix}-period`}><SelectValue /></SelectTrigger>
        <SelectContent>{PERIODOS.map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent>
      </Select>
      {value.period === "rango" && (
        <div className="flex items-center gap-2">
          <Input type="date" value={value.desde} onChange={(e) => set("desde", e.target.value)} className="w-40" aria-label="Fecha desde" data-testid={`${prefix}-desde`} />
          <span className="text-xs text-[#6B7678]">a</span>
          <Input type="date" value={value.hasta} onChange={(e) => set("hasta", e.target.value)} className="w-40" aria-label="Fecha hasta" data-testid={`${prefix}-hasta`} />
          {value.desde && value.hasta && value.desde > value.hasta && (
            <span className="text-xs text-red-600" data-testid={`${prefix}-rango-error`}>La fecha "desde" es posterior a "hasta"</span>
          )}
        </div>
      )}
      {showTipo && (
      <Select value={value.tipo} onValueChange={(v) => set("tipo", v)}>
        <SelectTrigger className="w-48" data-testid={`${prefix}-tipo-filter`}><SelectValue /></SelectTrigger>
        <SelectContent>
          <SelectItem value="all">Todos los tipos</SelectItem>
          {TIPOS_UNIDAD.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}
        </SelectContent>
      </Select>
      )}
    </>
  );
}

export function LeadPeriodCounter({ rows, prefix }) {
  const counts = Object.fromEntries(TIPOS_UNIDAD.map((t) => [t, 0]));
  rows.forEach((r) => { counts[tipoOf(r)] += 1; });
  return (
    <div className="mb-4 rounded-sm border border-[#3E5641]/10 bg-[#F1F3F3]/50 px-4 py-3" data-testid={`${prefix}-counter`}>
      <p className="text-sm font-medium text-[#3E5641]">
        <span data-testid={`${prefix}-count`}>{rows.length}</span> {rows.length === 1 ? "lead" : "leads"} en este periodo
      </p>
      <p className="mt-1 text-xs text-[#6B7678]">
        {TIPOS_UNIDAD.map((t, i) => (
          <span key={t}>{i > 0 && " · "}{t}: <strong className="text-[#3E5641]" data-testid={`${prefix}-count-${t.replace(" ", "-").toLowerCase()}`}>{counts[t]}</strong></span>
        ))}
      </p>
    </div>
  );
}

export function TipoUnidadSelect({ value, onChange, testId }) {
  return (
    <Select value={value || "Sin definir"} onValueChange={onChange}>
      <SelectTrigger data-testid={testId}><SelectValue /></SelectTrigger>
      <SelectContent>{TIPOS_UNIDAD.map((t) => <SelectItem key={t} value={t}>{t}</SelectItem>)}</SelectContent>
    </Select>
  );
}

export const LEAD_FILTER_INITIAL = { period: "todo", desde: "", hasta: "", tipo: "all" };
